export const SIGNIN_ROUTE = '/signin'
export const REGISTER_ROUTE = '/register'
export const HOME_ROUTE = '/'
export const USER_PAGE = '/userpage'
export const VIDEO_PAGE = '/videoinfo'
export const ACCOUNT_PAGE = '/account'
